import { useNode, useEditor } from "@craftjs/core";
import React from "react";
import { ColumnsSettings } from "./settings";
import GrigoraCSSRenderer from "./../css-render";
import classNames from "classnames";
import { Column } from "../column";
import { ReactComponent as Icon50x50 } from "./../../../assets/columns-icon/50-50.svg";
import { ReactComponent as Icon30x70 } from "./../../../assets/columns-icon/30-70.svg";
import { ReactComponent as Icon70x30 } from "./../../../assets/columns-icon/70-30.svg";
import { ReactComponent as Icon33x33x33 } from "./../../../assets/columns-icon/33-33-33.svg";
import { ReactComponent as Icon25x25x25x25 } from "./../../../assets/columns-icon/25-25-25-25.svg";
import { getRandomId as getRandomNodeId } from "@craftjs/utils";
import icon from "./icon";
import { CMSColumnsSettings } from "./cms-settings";
import classnames from "classnames";
import { getDynamicCSS, getSupportProps } from "../../block-supports";
import CMSIcon from "./cms-icon";

export const Columns = (props) => {
  const {
    id,
    connectors: { connect, drag },
    actions: { setProp },
  } = useNode((state) => ({
    id: state.id,
    selected: state.events.selected,
    dragged: state.events.dragged,
  }));

  const {
    query: { node, parseFreshNode },
    actions: { add },
  } = useEditor();

  const childrens = node(id).childNodes();

  const {
    children,
    columnsCount = node(id).childNodes().length,
    tabletColumnsCount = 1,
    mobileColumnsCount = 1,
  } = props;

  var blockProps = getSupportProps({
    id,
    ...props,
  });

  const wrapperClass = classnames(
    {
      "g-columns": true,
      [`columns-${id}`]: id,
      "collapse-tablet": tabletColumnsCount < childrens.length,
      "collapse-mobile": mobileColumnsCount < childrens.length,
    },
    blockProps.className,
  );

  const addColumn = (dimensions) => {
    dimensions.map((item, index) => {
      let freshNode = {
        id: getRandomNodeId(),
        data: {
          type: Column,
          props: {
            width: `${item}%`,
          },
          isCanvas: true,
        },
      };
      let nodeToAdd = parseFreshNode(freshNode).toNode();
      add(nodeToAdd, id);
    });
  };

  return (
    <div
      {...blockProps}
      ref={(ref) => connect(drag(ref))}
      className={wrapperClass}
      data-grigora-block="true"
      data-grigora-block-id={id}
    >
      <style>{`${getDynamicCSS(id, props)}`}</style>
      <style>{`${GrigoraCSSRenderer.blockCSS__Columns(id, props)}`}</style>
      {childrens.length === 0 ? (
        <div className="columns-selector">
          <div className="columns-selector__title">Columns</div>
          <div className="columns-selector__inner">
            <div
              onClick={() => {
                addColumn([50, 50]);
                setProp((props) => {
                  props.columnsCount = 2;
                });
              }}
              className="columns-selector__inner-item"
            >
              <Icon50x50 />
            </div>
            <div
              onClick={() => {
                addColumn([33, 33, 33]);
                setProp((props) => {
                  props.columnsCount = 3;
                });
              }}
              className="columns-selector__inner-item"
            >
              <Icon33x33x33 />
            </div>
            <div
              onClick={() => {
                addColumn([25, 25, 25, 25]);
                setProp((props) => {
                  props.columnsCount = 4;
                });
              }}
              className="columns-selector__inner-item"
            >
              <Icon25x25x25x25 />
            </div>
            <div
              onClick={() => {
                addColumn([30, 70]);
                setProp((props) => {
                  props.columnsCount = 2;
                });
              }}
              className="columns-selector__inner-item"
            >
              <Icon30x70 />
            </div>
            <div
              onClick={() => {
                addColumn([70, 30]);
                setProp((props) => {
                  props.columnsCount = 2;
                });
              }}
              className="columns-selector__inner-item"
            >
              <Icon70x30 />
            </div>
          </div>
          <div className="columns-selector__text">
            Need something else from the above layouts?<br></br> Choose any one
            of the layouts, and you can still change the dimension of each
            column as you need.
          </div>
        </div>
      ) : (
        <>{children}</>
      )}
    </div>
  );
};

// To Avoid Mangling in Production
Columns.displayName = "Columns";

Columns.craft = {
  name: "Columns",
  props: {},
  related: {
    CMSsettings: CMSColumnsSettings,
    settings: ColumnsSettings,
    icon: icon,
    CMSIcon: CMSIcon,
    supports: [
      "grigora/directory-conditional",
      "grigora/entrance-animations",
      "grigora/css-transform-animations",
      "grigora/mouse-movement",
      "grigora/visibility",
      "grigora/position",
      "grigora/sticky",
      "grigora/filter",
      "grigora/custom-class",
      "grigora/custom-id",
    ],
    category: "layout",
    supportNestedBlocks: true,
    isHiddenInPostEditor: true,
    keywords: ["Columns", "Sections", "Vertical"],
  },
  custom: {
    name: "Columns",
    slug: "grigora/columns",
  },
  rules: {
    canMoveIn: (incomingNodes) =>
      incomingNodes.every((incomingNode) => incomingNode.data.type === Column),

    canMoveOut: (outgoingNodes) =>
      outgoingNodes.every(
        (outgoingNodes) => outgoingNodes.data.type !== Column,
      ),
  },
};
